import { createAction, props } from '@ngrx/store';
import { IPendingInvitedTabBusinessManagementUsersRequest } from '../models/pending-invited-business-managment-users.model';
import { IPendingInvitedEmployeesQuickSearchResponse } from '../../../shared/models/shared.model';

export const loadDirectorsPendingInvitedBusinessManagementUserQuickSearch = createAction(
  '[DirectorsPendingInvitedBusinessManagementUserQuickSearch] Load Directors PendingInvitedBusinessManagementUserQuickSearch',
  props<{
    businessId: string;
    userRoleIds: string[];
    request: IPendingInvitedTabBusinessManagementUsersRequest;
  }>()
);

export const loadDirectorsPendingInvitedBusinessManagementUserQuickSearchSuccess = createAction(
  '[DirectorsPendingInvitedBusinessManagementUserQuickSearch] Load Directors PendingInvitedBusinessManagementUserQuickSearch Success',
  props<{ response: IPendingInvitedEmployeesQuickSearchResponse }>()
);

export const loadDirectorsPendingInvitedBusinessManagementUserQuickSearchFailure = createAction(
  '[DirectorsPendingInvitedBusinessManagementUserQuickSearch] Load Directors PendingInvitedBusinessManagementUserQuickSearch Failure',
  props<{ error: Error | any }>()
);

export const saveGroupUserRoleIds = createAction(
  '[DirectorsPendingInvitedBusinessManagementUserQuickSearch] Save GroupUserRoleIds',
  props<{ userRoleIds: string[] }>()
);

export const clearDirectorsPendingInvitedBusinessManagementUserQuickSearch = createAction(
  '[DirectorsPendingInvitedBusinessManagementUserQuickSearch] Clear Directors PendingInvitedBusinessManagementUserQuickSearch'
);

export const isDirectorsPendingInvitedFirstTimeLoad = createAction(
  '[DirectorsPendingInvitedBusinessManagementUserQuickSearch First Time Loaded] Directors isDirectorsPendingInvitedFirstTimeLoad',
  props<{ firstTimeLoad: boolean }>()
);
